import { Navbar, Image, NavDropdown, Nav } from 'react-bootstrap';

import Container from 'react-bootstrap/Container';
import { PersonCircle, Book, Messenger } from 'react-bootstrap-icons';
import NumberFormat from "react-number-format"

import "./navigator.scss";

import logo from "../../imgs/logo.png";
import { useSelector, useDispatch } from 'react-redux';
import { getAccessToken, getUserData } from '../../store/auth/selector';

import * as authActions from "../../store/auth/actions";
import { useTranslation } from 'react-i18next';
import { getAppInfo, getGateConf } from '../../store/app/selector';

// import { showMessenger } from "react-messenger-chat-plugin"

const GameNavigation = ({home}) => {

    const { t } = useTranslation('translations');

    const dispath = useDispatch();

    
    const appInfo = useSelector(state => getAppInfo(state))
    const userData = useSelector(state => getUserData(state, appInfo));
    const access_token = useSelector(state => getAccessToken(state, appInfo))    
    const gateConf = useSelector(state => getGateConf(state))

    const logout = (e) => {
        e.preventDefault();
        dispath(authActions.logout())
    }


    const userMenuToggle = (isOpen, e, metadata) => {
        if (isOpen) {
            dispath(authActions.verifyToken(access_token, appInfo, gateConf.apiUrl))
        }
    }

    return (
        <>
            <Navbar bg="light" expand="lg" className="main" fixed={true}>
                <Container>
                    <Navbar.Brand href={"/"}>
                        <Image src={logo} alt="" ></Image>
                    </Navbar.Brand>

                    <div className="navbar-custom-menu">
                        <Nav as="ul">

                            {(userData && !home) && <Nav.Item as="li"><NavDropdown
                                onToggle={userMenuToggle}
                                id="nav-dropdown-user"
                                title={<PersonCircle />}
                            >
                                <div className="user-header">
                                    <div className="username item">
                                        {userData.username}
                                    </div>
                                    <div className="userid item">
                                        ID:  {userData.userid}
                                    </div>
                                    <div className="uservip item">Vip.{userData.vip}</div>
                                    <NumberFormat
                                        value={userData.chip}
                                        className={'userchip item'}
                                        suffix={' Chips'}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        renderText={(value, props) => <div {...props}>{value}</div>}
                                    />
                                </div>
                                <div className="user-footer">
                                    <a className="logout" href="#logout" type="button" onClick={logout}>Logout</a>
                                </div>
                            </NavDropdown></Nav.Item>}

                            <Nav.Item><Nav.Link href="/guide"><Book /> <span>{t('txt1')}</span></Nav.Link></Nav.Item>
                            <Nav.Item><Nav.Link href="https://m.me/107904838432832" ><Messenger /> <span>{t('txt2')}</span></Nav.Link></Nav.Item>
                        </Nav>
                    </div>
                </Container>
            </Navbar>
        </>
    );
}

export default GameNavigation;